import { getJson } from './ServiceHelperMethods'

class PriceService {

    static async getWorkspacePrices() {
        return await getJson(`workspaces/prices`);
    }
}

export default PriceService;